export default __webpack_public_path__ + "static/media/1332.4e98f6c6.png";